var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 19.1665,
    width: 20,
    height: 1.66667,
    rx: 0.833333,
    fill: "#555893"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V15.5C22 16.491 21.2792 17.3137 20.3333 17.4723V15.8335C20.3181 14.9765 20.1896 13.3061 18.2324 12.7143C17.7926 13.1 17.2159 13.3334 16.5833 13.3334C15.9418 13.3334 15.3576 13.0932 14.9155 12.6977C12.877 13.2636 12.8491 14.9065 12.8342 15.785L12.8333 15.8335V17.5H11.1667V15.8335C11.1514 14.9765 11.023 13.3062 9.0659 12.7143C8.62612 13.1001 8.04928 13.3336 7.41667 13.3336C6.77502 13.3336 6.19074 13.0934 5.74866 12.6977C3.71029 13.2637 3.68241 14.9065 3.6675 15.785L3.66667 15.8335V17.4723C2.72076 17.3137 2 16.491 2 15.5V7ZM16.5833 9.16667C17.5056 9.16667 18.25 9.91111 18.25 10.8333C18.25 11.7556 17.5056 12.5 16.5833 12.5C15.6611 12.5 14.9167 11.7556 14.9167 10.8333C14.9167 9.91111 15.6611 9.16667 16.5833 9.16667ZM9.08333 10.8333C9.08333 9.91111 8.33889 9.16667 7.41667 9.16667C6.49444 9.16667 5.75 9.91111 5.75 10.8333C5.75 11.7556 6.49444 12.5 7.41667 12.5C8.33889 12.5 9.08333 11.7556 9.08333 10.8333Z",
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutor);
export default __webpack_public_path__ + "static/media/tutor.f01c39ce.svg";
export { ForwardRef as ReactComponent };